const status = [
  { name: 'Unapproved', value: 'U' },
  { name: 'Unapproved - Acknowledged', value: 'UA' },
  { name: 'Unapproved - Communicated', value: 'UC' },
  { name: 'Approved', value: 'A' },
  { name: 'Approved - Needs Coverage', value: 'AN' },
  { name: 'Approved - Covered', value: 'AC' },
  { name: 'On Hold', value: 'H' },
  { name: 'Denied', value: 'D' }
]

export default status;